/* eslint-disable  react/prop-types */

import React from 'react';

const MiniCalendarIcon = ({ width = 16, height = 16, style = {} }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="mini-calendar-icon"
  >
    <path
      d="M13.2 1H12V0H10V1H6V0H4V1H2.8C1.3 1 0 2.2 0 3.7V6.4V8.4V13.2C0 14.8 1.3 16 2.8 16H13.2C14.8 16 16 14.8 16 13.3V8.5V6.5V3.7C16 2.2 14.7 1 13.2 1ZM14 13.3C14 13.7 13.6 14 13.2 14H2.8C2.4 14 2 13.7 2 13.3V8.5H14V13.3ZM2 6.5V3.7C2 3.3 2.4 3 2.8 3H4V4H6V3H10V4H12V3H13.2C13.6 3 14 3.3 14 3.7V6.4H2V6.5Z"
      fill="#183358"
    />
  </svg>
);

export default MiniCalendarIcon;
